import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const agents = createQueryKeys('agents', {
  all: null,
})

export type CountryKeys = inferQueryKeys<typeof agents>
